import { api } from './api';

export const generateTracks = (token, start, end, force = false) =>
  api.post(
    '/hr-commissions/tracks/generate',
    { period: { start, end }, force_rebuild_unpaid: force },
    token
  );

export const listTracks = (token, params = {}) =>
  api.get('/hr-commissions/tracks', token, { params });

export const getTrack = (token, id) =>
  api.get(`/hr-commissions/tracks/${id}`, token);

export const markTrackPaid = (token, id, payload = {}) =>
  api.post(`/hr-commissions/tracks/${id}/mark-paid`, payload, token);

export const voidTrack = (token, id) =>
  api.post(`/hr-commissions/tracks/${id}/void`, {}, token);

export const downloadTracksPdf = async (token, start, end, agentId = null) => {
  const response = await api.post(
    '/hr-commissions/tracks/pdf',
    { period: { start, end }, agent_id: agentId },
    token,
    { responseType: 'blob' }
  );
  return response;
};

export const getAutomationSettings = (token) =>
  api.get('/hr-commissions/automation/settings', token);

export const updateAutomationSettings = (token, payload) =>
  api.put('/hr-commissions/automation/settings', payload, token);

export const listAutomationHistory = (token, limit = 20) =>
  api.get('/hr-commissions/automation/history', token, { params: { limit } });

export const triggerAutomationRun = (token) =>
  api.post('/hr-commissions/automation/run', {}, token);
